import React from "react";
import cvData from "../data/cvData.json";

const Skills = () => {
  const { skills } = cvData;

  return (
    <section id="skills" className="relative z-10 mx-auto w-full max-w-6xl px-6 py-12">
      <div className="glass-panel glass-sheen p-6 md:p-10">
        <h2 className="section-title">Professional Skills &amp; Expertise</h2>
        <p className="mt-4 text-sm text-text-secondary">
          Full-stack development expertise with modern frameworks and enterprise platforms
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          {skills.map((skill, index) => (
            <span key={index} className="glass-chip" itemProp="knowsAbout">
              {skill}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
